import * as React from 'react'

import { StyledAlert } from './Alert.glamorous'

export type Props = {
  type?: string;
  className?: string;
}

export const Alert: React.SFC<Props> = ({ children, type = 'error', className }) => (
  <StyledAlert className={`alert ${className}`} type={type}>{children}</StyledAlert>
)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Alert/Alert.tsx